<template>
<div v-if="ready" style="padding:20px 20px 20px 20px;">
  <schedaHeader scheda="2" titolo="SCHEDA PERINATALE" :item="item"></schedaHeader>


  <el-form ref="formBasic" :model="item.row" @submit.native.prevent="onSubmit" :rules="rulesForm" label-width="360px" class="label-50">



   <div class="formRow row">

      <div class="col s12" v-if="item.row.gruppo==1">       
         <formLabel variabile="pcare"></formLabel>       
         <el-form-item prop="pcare">       
            <formSelectV3 v-model="item.row.pcare" variabile="pcare"></formSelectV3>       
         </el-form-item>       
      </div>

      <div class="col s12" v-if="item.row.gruppo==1">       <formLabel variabile="patomadre"></formLabel>       <el-form-item prop="patomadre">       <formSelectV3 v-model="item.row.patomadre" variabile="patomadre"></formSelectV3>       </el-form-item>       </div>

        <div class="col s12" v-if="item.row.patomadre==1 && item.row.gruppo==1">       <formLabel variabile="patomadretipo"></formLabel>       <el-form-item prop="patomadretipo">       <formSelectV3 v-model="item.row.patomadretipo" variabile="patomadretipo"></formSelectV3>       </el-form-item>       </div>


      <div class="col s12">       <formLabel variabile="pma"></formLabel>       <el-form-item prop="pma">       <formSelectV3 v-model="item.row.pma" variabile="pma"></formSelectV3>       </el-form-item>       </div>
      <div class="col s12">       <formLabel variabile="mhypertens"></formLabel>       <el-form-item prop="mhypertens">       <formSelectV3 v-model="item.row.mhypertens" variabile="mhypertens"></formSelectV3>       </el-form-item>       </div>
      <div class="col s12">       <formLabel variabile="mdiabetes"></formLabel>       <el-form-item prop="mdiabetes">       <formSelectV3 v-model="item.row.mdiabetes" variabile="mdiabetes"></formSelectV3>       </el-form-item>       </div>
      <div class="col s12">       <formLabel variabile="aster"></formLabel>       <el-form-item prop="aster">       <formSelectV3 v-model="item.row.aster" variabile="aster"></formSelectV3>       </el-form-item>       </div>
      <div class="col s12" v-if="item.row.aster==1">       <formLabel variabile="tipoaster"></formLabel>       <el-form-item prop="tipoaster">       <formSelectV3 v-model="item.row.tipoaster" variabile="tipoaster"></formSelectV3>       </el-form-item>       </div>
      <div class="col s12" v-if="item.row.gruppo==1">       <formLabel variabile="amagsulf"></formLabel>       <el-form-item prop="amagsulf">       <formSelectV3 v-model="item.row.amagsulf" variabile="amagsulf"></formSelectV3>       </el-form-item>       </div>
      <div class="col s12" v-if="item.row.gruppo==1">       <formLabel variabile="iugr"></formLabel>       <el-form-item prop="iugr">       <formSelectV3 v-model="item.row.iugr" variabile="iugr"></formSelectV3>       </el-form-item>       </div>
      <div class="col s12" v-if="item.row.gruppo==1">       <formLabel variabile="benfetale"></formLabel>       <el-form-item prop="benfetale">       <formSelectV3 v-model="item.row.benfetale" variabile="benfetale"></formSelectV3>       </el-form-item>       </div>
      
      <div class="col s12">       <formLabel variabile="mult"></formLabel>       <el-form-item prop="mult">       <formSelectV3 v-model="item.row.mult" variabile="mult"></formSelectV3>       </el-form-item>       </div>
      <div class="col s12" v-if="item.row.mult==1">       <formLabel variabile="nbirths"></formLabel>       <el-form-item prop="nbirths">       <formRangeV3 v-model="item.row.nbirths" variabile="nbirths"></formRangeV3>       </el-form-item>       </div>
      <div class="col s12" v-if="item.row.mult==1">       <formLabel variabile="tttdec"></formLabel>       <el-form-item prop="tttdec">       <formSelectV3 v-model="item.row.tttdec" variabile="tttdec"></formSelectV3>       </el-form-item>       </div>
      <div class="col s12" v-if="item.row.mult==1">       <formLabel variabile="multmonoc"></formLabel>       <el-form-item prop="multmonoc">       <formSelectV3 v-model="item.row.multmonoc" variabile="multmonoc"></formSelectV3>       </el-form-item>       </div>
      
      <div class="col s12">       <formLabel variabile="congeninf"></formLabel>       <el-form-item prop="congeninf">       <formSelectV3 v-model="item.row.congeninf" variabile="congeninf"></formSelectV3>       </el-form-item>       </div>

      <div class="formCol col s12" v-if="item.row.congeninf==1">
      <formLabel variabile="congeninfcd1"></formLabel>
      <el-form-item prop="congeninfcd1" v-on:change="ebsepscd()" >   
      <formSelectV3  v-model="item.row.congeninfcd1" variabile="congeninfcd1"></formSelectV3>
      </el-form-item>
      </div>

      <div class="formCol col s12" v-if="item.row.congeninf==1 && item.row.congeninfcd1>0">
      <formLabel variabile="congeninfcd2"></formLabel>
      <el-form-item prop="congeninfcd2"  v-on:change="ebsepscd()" >   
      <formSelectV3  v-model="item.row.congeninfcd2" variabile="congeninfcd2"></formSelectV3>
      </el-form-item>
      </div>

      <div class="formCol col s12" v-if="item.row.congeninf==1 && item.row.congeninfcd2>0">
      <formLabel variabile="congeninfcd3"></formLabel>
      <el-form-item prop="congeninfcd3"  >   
      <formSelectV3  v-model="item.row.congeninfcd3" variabile="congeninfcd3"></formSelectV3>
      </el-form-item>
      </div>

      <div class="col s12" v-if="item.row.gruppo==1">       <formLabel variabile="chorio"></formLabel>       <el-form-item prop="chorio">       <formSelectV3 v-model="item.row.chorio" variabile="chorio"></formSelectV3>       </el-form-item>       </div>
      <div class="col s12" v-if="item.row.gruppo==1">       <formLabel variabile="anomplacenta"></formLabel>       <el-form-item prop="anomplacenta">       <formSelectV3 v-model="item.row.anomplacenta" variabile="anomplacenta"></formSelectV3>       </el-form-item>       </div>
      <div class="col s12">       <formLabel variabile="prom"></formLabel>       <el-form-item prop="prom">       <formSelectV3 v-model="item.row.prom" variabile="prom"></formSelectV3>       </el-form-item>       </div>
      <div class="col s12">       <formLabel variabile="initrav"></formLabel>       <el-form-item prop="initrav">       <formSelectV3 v-model="item.row.initrav" variabile="initrav"></formSelectV3>       </el-form-item>       </div>
      <div class="col s12">       <formLabel variabile="vagdel"></formLabel>       <el-form-item prop="vagdel">       <formSelectV3 v-model="item.row.vagdel" variabile="vagdel"></formSelectV3>       </el-form-item>       </div>


   </div>

    <div v-if="item.row.chiusoil=='0000-00-00 00:00:00'" class="row" style="margin-top:20px;border-top:1px solid #379EC2;padding-top:20px;">           
      <div class="col s12 m3">
        <el-button style="width:100%;"  v-on:click="onCancel">Indietro</el-button>
        </div> 
      <div class="col s12 m4 offset-m5">
        <el-button type="primary" @click="onSubmit" class="yo-bg-color-secondary" style="width:100%;border:none;">Salva e procedi</el-button>
      </div>
    </div>

    <div v-else class="row" style="margin-top:20px;border-top:1px solid #379EC2;padding-top:20px;">           
      <div class="col s12 m4 offset-m8" >
        <el-button style="width:100%;"  @click="$router.push('/home')">Annulla</el-button>
      </div>
    </div>


  



  </el-form>



</div>
</template>

<script>
/*
QUERY
SELECT id,LOWER(nome),posizione,tipo,risposte,answer,nc,na,domanda,help FROM `variabile` WHERE scheda=2 ORDER BY posizione
*/
import schedaHeader from './Scheda-header.vue'
import formLabel from './Form-label.vue'
import formSelectV3 from './Form-select-v3.vue'
import formRangeV3 from './Form-range-v3.vue'

import dbItem from '../teras/dbItem'

export default {
  name: 'scheda-datigenerali',
  components: {
     schedaHeader
     ,formLabel
     ,formSelectV3
     ,formRangeV3
  },
  data() {
    return {
      loading:{}
      ,ready: false
      ,item:{}
      ,rowBanca:[]
    }
  },
  created: async function () {
    console.log("Arrivo  scheda-datigenerali.vue con id "+this.$route.params.id)
    this.loading = this.$loading({lock: true, text: 'Caricamente in corso, non ricaricare la pagina.....', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })

    this.item = new dbItem({table:'paziente'})
    await this.item.load(this.$route.params.id)
    if(this.item.row.centro==0)
      this.item.row.centro = this.$centro.referente.row.centro

    if(this.item.rowIsNew){
      this.item.row.creatoil=this.$moment().format('YYYY-MM-DD H:mm:ss')
      this.item.row.creatoda=this.$teras.utente.id//this.$centro.referente.row.id

      this.item.row.byear = this.$moment().format('YYYY')
    }else{
      //mettere il nome della pagina cme modifica
    }

    for (let property in this.item.row){
      if(this.item.row[property]==-7)
        this.item.row[property]=-127
    }
    
    setTimeout(() =>{ 
      this.loading.close()
      this.ready = true 
    }, 1000)


  },
  methods: {
    congeninfcd: function(){
      if(this.item.row.congeninfcd1<0){
        this.item.row.congeninfcd2=-127
      }
      if(this.item.row.congeninfcd2<0){
        this.item.row.congeninfcd3=-127
      }
    },
    onSubmit: async function() {
      this.$refs.formBasic.validate(async (valid) => {
        if (valid) {      
          this.loading = this.$loading({lock: true, text: 'Caricamente in corso, non ricaricare la pagina.....', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })

          this.item.row.modificatoil=this.$moment().format('YYYY-MM-DD H:mm:ss')
          this.item.row.modificatoda=this.$teras.utente.id//this.$centro.referente.row.id


          let error = -1
          if(this.item.row.initrav==3 && this.item.row.vagdel==1)
            error = 201

          switch (error){
            case -1:
            if(this.item.row.chiusoil=='0000-00-00 00:00:00'){
              await this.item.save()
              await this.$axios.query('doQuery',`CALL paziente_check_risposte(←id,@nome, @numero);`,{id: this.item.row.id})
              await this.$centro.getPaziente()
            }
            this.$router.push('/scheda-salaparto/'+this.item.row.id)
            break;

            case 201:
            this.$notify.error({title: 'Errore '+error,message: 'Se non si è verificato alcun travaglio, non può essere un parto vaginale!'})
            break;

            default:
            this.$notify.error({title: 'Errore non specificato',message: 'Siamo spiacenti si è verificato un errore, la preghiamo di verificare i dati inseriti!'})
          }
          
          this.loading.close()




          
          
        } else {
          this.$notify.error({title: 'Errore',message: "Non tutti i campi sono stati compilati correttamente!"})
          return false
        }
      })
    }
    ,onCancel() {
        //this.$router.go(-1)
        this.$router.push('/scheda-datigenerali/'+this.item.row.id)
    }

  },
  computed: {
    rulesForm:function() {
      var rulesNow = {
        /*
        importo: [
          //{ required: true, message: 'L\'importo è obbligatorio' },
          { min: 1, max: 5000, message: 'Bisogna indicare un importo', trigger: 'blur' }
        ],
        */
        ncartellaclinica: [
          { required: true, message: 'Il numerodi cartella clinica è obbligatorio' }
        ],
        step: [
          { required: true, message: 'Lo status è obbligatorio'}
        ],
        eseguitoil: [
          { required: true, message: 'Il giorno di esecuzione è obbligatorio'}
        ],
        incassatoil: [
          { required: true, message: 'Il giorno di incasso è obbligatorio'}
        ]

      }
      return rulesNow
    }
  }
}
</script>
<style >
.formRow > .col {
    background-color: #F9F9FA;
}.formRow > .col:nth-child(odd) {
    background-color: #EFF0F2;
}.formRow > .col .el-form-item{
  margin-top:10px;
  margin-bottom:18px;
}.formRow > .col .el-form-item__content{
  margin-right:12px;

  
}
</style>